
(function () {
  if (window.scfPriorityInitialized) return;
  window.scfPriorityInitialized = true;

  const handle = 'skip-the-queue-priority-production';
  const root = window.Shopify?.routes?.root || '/';

  let busy = false;
  let pending = false;
  let variantPromise;

  async function request(path, options) {
    const response = await fetch(root + path, options);
    const data = await response.json();

    if (!response.ok || data.errors) {
      throw new Error('Priority Production cart update failed');
    }

    return data;
  }

  async function getVariantId() {
    if (!variantPromise) {
      variantPromise = request(
        'products/' + handle + '.js'
      ).then(product => product.variants[0].id);
    }
    return variantPromise;
  }

  async function getEligibleQuantity() {
    const response = await fetch(
      root + '?sections=cart-sidebar-footer'
    );

    if (!response.ok) {
      throw new Error('Unable to retrieve cart footer');
    }

    const sections = await response.json();
    const html = sections['cart-sidebar-footer'];

    if (typeof html !== 'string') {
      throw new Error('Cart footer unavailable');
    }

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const element = doc.querySelector('#scf-eligible-quantity');

    if (!element) {
      const cart = await request('cart.js');
      if (cart.item_count === 0) return 0;
      throw new Error('Eligible quantity marker missing');
    }

    const quantity = Number(element.dataset.quantity);

    if (!Number.isInteger(quantity) || quantity < 0) {
      throw new Error('Invalid eligible quantity');
    }

    return quantity;
  }

  async function refreshCart() {
    const sidebar = document.querySelector('cart-sidebar');

    if (sidebar) {
      await sidebar.reload();
    }

    // Refresh full cart page when it is visible.
    if (document.querySelector('cart-items')) {
      window.location.reload();
    }
  }

  async function reconcile() {
    if (busy) {
      pending = true;
      return;
    }

    busy = true;

    try {
      do {
        pending = false;

        const id = await getVariantId();
        const cart = await request('cart.js');

        const existing = cart.items.find(
          item => String(item.variant_id) === String(id)
        );

        const eligible = await getEligibleQuantity();
        const current = existing ? existing.quantity : 0;

        const checkbox = document.getElementById(
          'scf-priority-checkbox'
        );

        // Existing add-on means priority was selected.
        const selected = checkbox
          ? checkbox.checked
          : current > 0;

        const desired = selected && eligible > 0
          ? eligible
          : 0;

        if (desired !== current) {
          const endpoint = existing
            ? 'cart/change.js'
            : 'cart/add.js';

          const body = existing
            ? { id: existing.key, quantity: desired }
            : { id: id, quantity: desired };

          await request(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
          });

          await refreshCart();
        }

      } while (pending);

    } catch (error) {
      console.error('SCF Priority Production:', error);
      alert('Unable to update Priority Production. Please check your cart.');
    } finally {
      busy = false;
    }
  }

  document.addEventListener('change', function (event) {
    if (event.target.id !== 'scf-priority-checkbox') return;

    const checkbox = event.target;
    checkbox.disabled = true;

    reconcile().finally(() => {
      checkbox.disabled = false;
    });
  });

  document.addEventListener(
    'scf:cart-quantity-updated',
    reconcile
  );
})();
